// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"56":"1d7c33f2","221":"c869a604","601":"8c0bbc1f"}[chunkId] + ".chunk.css";
};